import { useSettings } from '@/data/Settings';
import { DRAWER_STATE_KEY } from '@/data/constants/hdmDataKey';
import { getStateUpdater, useInitState, useSetState, useTrackedState } from '@/data/state/provider';
import { DrawerState } from '@/data/types/ColorType';
import { getStateKey } from '@/data/utils/getStateKey';
import { useCallback, useMemo } from 'react';

const DRAWER_BASE: DrawerState = {
	cartOpen: false,
	initialized: false,
};

export const useDrawerState = () => {
	const { settings } = useSettings();
	const key = useMemo(() => getStateKey(DRAWER_STATE_KEY, settings), [settings]);
	const baseState = useInitState(key, DRAWER_BASE);
	const drawerUpdater = useMemo(() => getStateUpdater({ key, baseState }), [baseState, key]);

	const setState = useSetState();
	const fullState = useTrackedState();
	const drawerState = (fullState[key] as DrawerState) || baseState;

	const openCartDrawer = useCallback(
		() =>
			drawerUpdater({
				setState,
				now: (current) => ({ ...current, cartOpen: true }),
			}),
		[setState, drawerUpdater]
	);

	const closeCartDrawer = useCallback(
		() =>
			drawerUpdater({
				setState,
				now: (current) => ({ ...current, cartOpen: false }),
			}),
		[setState, drawerUpdater]
	);

	return {
		drawerState,
		actions: { openCartDrawer, closeCartDrawer },
	};
};
